import { create } from 'zustand'
import type { Toast } from '@/types'

interface ToastStore {
  toasts: Toast[]
  add: (toast: Omit<Toast, 'id'>) => string
  remove: (id: string) => void
  clear: () => void
}

let _toastId = 0

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],

  add: (toast) => {
    const id = `toast-${++_toastId}`
    set((state) => ({ toasts: [...state.toasts, { ...toast, id }] }))
    const duration = toast.duration ?? 4000
    if (duration > 0) {
      setTimeout(() => {
        set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }))
      }, duration)
    }
    return id
  },

  remove: (id) =>
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),

  clear: () => set({ toasts: [] }),
}))

// Convenience helpers
export const toast = {
  success: (title: string, description?: string) =>
    useToastStore.getState().add({ variant: 'success', title, description }),
  error: (title: string, description?: string) =>
    useToastStore.getState().add({ variant: 'error', title, description }),
  warning: (title: string, description?: string) =>
    useToastStore.getState().add({ variant: 'warning', title, description }),
  info: (title: string, description?: string) =>
    useToastStore.getState().add({ variant: 'info', title, description }),
}
